import React, { useState } from "react";
import { MMI, SectorBar, PiTable } from "../../components/analytics";

function useIsMobile(breakpoint = 1137) {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  React.useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < breakpoint);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
}

function useIsBreakpoint(breakpoint = 1653) {
  const [isBreakpoint, setIsBreakpoint] = React.useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  React.useEffect(() => {
    function handleResize() {
      setIsBreakpoint(window.innerWidth < breakpoint);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isBreakpoint;
}

const LifeofPi = () => {
  const isMobile = useIsMobile(); // Detect if the user is on mobile
  const isBreakpoint = useIsBreakpoint();
  const [selectedSector, setSelectedSector] = useState("All Sectors");

  return (
    <div className="flex flex-col bg-darkMode-background p-6 h-full shrink">
      {/* Heading & Subtext */}
      <div className="flex flex-col pb-6">
        <h1 className="text-4xl md:text-5xl font-bold mb-2 text-darkMode-text">
          Pi <span className="text-market-teal">(Predictive Intelligence)</span>
        </h1>
        <span className="text-sm text-darkMode-subText">
          A real-time momentum engine that tracks smart money flow to spot
          breakout stocks before the move happens.{" "}
        </span>
      </div>

      {/* Content Section (Responsive) */}
      <div className="grid gap-3 w-full grid-cols-1  sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <div className="bg-darkMode-layer1 rounded-xl shadow-lg col-span-2">
          <SectorBar onSectorClick={setSelectedSector} />
        </div>
        <div className="bg-darkMode-layer1 rounded-xl shadow-lg col-span-1 md:col-span-2 lg:col-span-1">
          <MMI />
        </div>
      </div>
      {/* PiTable Section (Responsive) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:px-0 items-start mt-6 w-full max-md:max-w-full">
        <PiTable title={"Pi Scanner - Bullish"} bullorbear={true} />
        <PiTable title={"Pi Scanner - Bearish"} bullorbear={false} />
      </div>
    </div>
  );
};

export default LifeofPi;
